import React from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';

import Social from '../../views/social';
import { userIsAuthenticated, userIsNotAuthenticated } from '../../helpers/auth.helper';
import Layout from '../layout';
import Login from '../../views/login';
import ConfirmInvite from '../../views/confirmInvite';
import Register from '../../views/register';
import ForgotPassword from '../../views/forgotPassword';
import PhoneCode from '../../views/phoneCode';
import CheckEmail2fa from '../../views/checkEmail2fa';
import ResetPassword from '../../views/resetPassword';
import Page404 from '../../views/page404';
import PageTitle from '../../components/pageTitle';
import NotPaymentPage from '../../views/payment';
import Favicon from '../layout/favicon';

const Main = ({ showRoutes, subscriber, show2faPages }) => (
  <BrowserRouter>
    <div>
      <Favicon />
      <PageTitle enableCoverColor={1} />
      {
        showRoutes
        ? subscriber.paid_licence
          ? <Switch>
            <Route exact path="/login" component={userIsNotAuthenticated(Login)} />
            <Route exact path="/forgot-password" component={userIsNotAuthenticated(ForgotPassword)} />
            {!!show2faPages && (<Route exact path="/phone-code/:id" component={userIsNotAuthenticated(PhoneCode)} />)}
            {!!show2faPages && (<Route exact path="/check-email" component={userIsNotAuthenticated(CheckEmail2fa)} />)}
            <Route exact path="/reset-password/:id/:code" component={userIsNotAuthenticated(ResetPassword)} />
            {!!subscriber.can_register && (<Route exact path="/register" component={userIsNotAuthenticated(Register)} />)}
            <Route exact path="/confirm-invite/:id/:code" component={userIsNotAuthenticated(ConfirmInvite)} />
            <Route exact path="/social-login" component={Social} />
            <Route path="/" name="Home" component={subscriber.is_public_portal ? Layout : userIsAuthenticated(Layout)} />
          </Switch>
          :
          <Switch>
            <Route path="/payment" exact component={NotPaymentPage} />
            <Redirect from="*" to="/payment" />
          </Switch>
        : <Switch>
          <Route path="/" component={Page404} />
        </Switch>
      }
    </div>
  </BrowserRouter>
);

Main.propTypes = {
};

export default Main;



// WEBPACK FOOTER //
// ./src/containers/main/Main.jsx